<template>
    <div>
        <div class="d-flex justify-content-between">
            <h6 class="font-weight-semi-bold">{{ 'winnings_table' | lang }}</h6>
            <b-button v-b-toggle="'multipliers'" variant="link">
                <fa-icon icon="caret-up" v-if="isVisible"></fa-icon>
                <fa-icon icon="caret-down" v-else></fa-icon>
            </b-button>
        </div>
        <b-collapse id="multipliers" v-model="isVisible">
            <interjackpot :game="game" v-if="game.name == 'Interjackpot'"></interjackpot>
            <jokerjackpot :game="game" v-else-if="game.name == 'Jokerjackpot'"></jokerjackpot>
            <dice :game="game" v-else-if="game.name == 'Dice'"></dice>
            <basic :game="game" v-else></basic>
        </b-collapse>
    </div>
</template>

<script>
import Basic from './Basic';
import Interjackpot from './Interjackpot';
import Jokerjackpot from './Jokerjackpot';
import Dice from './Dice';

import { syncFrameHeight } from "@tv/helpers";

export default {
    props: ['gameId'],

    components: { Basic, Interjackpot, Jokerjackpot, Dice },

    data() {
        return {
            isVisible: true,
        };
    },
    
    computed: {
        game() {
            return Config.games[this.gameId];
        },
    },

    watch: {
        isVisible() {
            syncFrameHeight();
        },
    },
}
</script>